module.exports = __webpack_public_path__ + "img/accruedDomonetization.c57876fd.svg";